import { useQuery } from '@tanstack/react-query';
import { getManifest } from 'Services';
import { RQ_MANIFEST } from 'Utils';

type Manifest = {
    name: string;
    short_name: string;
    author: string;
    display: string;
    timestamp: string;
    version: string;
    on_premises_version: string;
    theme_color: string;
    background_color: string;
    start_url: string;
};

function useGetManifest() {
    return useQuery<Manifest>([RQ_MANIFEST], getManifest);
}

export default useGetManifest;
